__turbopack_context__.v({
  "count": "m2_9aq_count",
  "face": "m2_9aq_face",
  "faces": "m2_9aq_faces",
  "line": "m2_9aq_line",
  "newBadge": "m2_9aq_newBadge",
  "root": "m2_9aq_root",
  "sep": "m2_9aq_sep",
  "suggestedLink": "m2_9aq_suggestedLink",
});
